





































































































































































































































































































































































































































































































































































































































































































































import { defineComponent, useContext } from '@nuxtjs/composition-api';
import { getMetaInfo } from '~/helpers/getMetaInfo';

export default defineComponent({
    name: 'OurStores',
    components: {

    },
    setup() {
        const context = useContext();
        // @ts-ignore
        const { imageProvider, magentoBaseUrl } = context.$vsf.$magento.config;
       
        const pageMeta = {
            "meta_title": null,
            "meta_description": null,
            "meta_keywords": null,
            "name": "Midwest Photo Store Location",
        };

        return {
            magentoBaseUrl,
            pageMeta
        }
    },
    head() {
        return getMetaInfo(this.pageMeta);
    },
})
